import React from 'react';

const Onboarding = React.lazy(() => import('./OnboardingV2'));

export default Onboarding;
